var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapSwitchOverflowHotWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.002,
    height: 69,
    viewBox: "0 0 202.002 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.541,
    x2: 0.5,
    y2: 0.576,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafa78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8cb36"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overflow_Hot_Water",
    "data-name": "Overflow Hot Water",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M86.23,68.35c-.09,0-.13-.01-79.38-12.46A7.022,7.022,0,0,1,.92,49.06L.65,9.82A4.149,4.149,0,0,1,4.77,5.59h.6c56.05-.07,101.5-.1,135.09-.1,29.13,0,47.89.03,55.77.08a4.776,4.776,0,0,1,4.75,4.76l.37,53.51a4.456,4.456,0,0,1-4.44,4.51Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M86.2,67.67c-.05,0-79.14-12.41-79.14-12.41-3.61-.3-5.44-3.01-5.5-6.13L1.3,10.28A3.861,3.861,0,0,1,4.9,6.4c24.96-.03,164.94-.1,191.52.08a3.982,3.982,0,0,1,3.88,4.16l.4,53.27c.03,2.13-1.15,3.79-3.55,3.79Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M200.07,67.02a4.45,4.45,0,0,0,1.28-3.18l-.37-53.51a4.769,4.769,0,0,0-4.75-4.76c-.33,0-.68,0-1.05-.01a9.119,9.119,0,0,0-3.91,2.12s-6.8,5.86-12.73,0a9.446,9.446,0,0,0-3.2-2.17c-1.46,0-2.98,0-4.57-.01a8.688,8.688,0,0,0-3.21,2.18s-6.45,6.21-12.73,0a10.015,10.015,0,0,0-3.15-2.19h-5.5a9.679,9.679,0,0,0-3.21,2.19s-5.84,7.62-12.55.98c-6.05-5.99-11.55-1.18-12.58-.18V8.43s-6.28,5.17-11.52,0-10.46,0-10.46,0-6.8,5.86-12.73,0-10.99,0-10.99,0-6.45,6.21-12.73,0-11.86,0-11.86,0S41.71,16.05,35,9.41c-5.93-5.86-11.33-1.35-12.5-.23-1.9,1.19-6.59,3.41-10.65-.6-5.23-5.17-10.46,0-10.46,0s-.25.21-.67.5a3.64,3.64,0,0,0-.07.74L.92,49.05a7.022,7.022,0,0,0,5.93,6.83c51.44,8.08,69.5,10.92,75.87,11.91H199A4.046,4.046,0,0,0,200.07,67.02Z",
    fill: "#ff001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M140.54,6.15c25.53,0,46.89.02,55.69.08a4.134,4.134,0,0,1,4.1,4.11l.37,53.5a3.786,3.786,0,0,1-3.78,3.85H86.23c-.05,0-79.28-12.45-79.28-12.45a6.4,6.4,0,0,1-5.38-6.2L1.3,9.82A3.482,3.482,0,0,1,4.77,6.25c16.58-.02,84.54-.1,135.77-.1m.05-1.31V6.15l-.02-1.31c-23.28,0-65.67.02-135.54.1H4.77A4.735,4.735,0,0,0,1.36,6.38,4.832,4.832,0,0,0,0,9.84L.27,49.05a7.688,7.688,0,0,0,6.48,7.48C86.03,68.99,86.06,68.99,86.13,69H196.92A5.088,5.088,0,0,0,202,63.83l-.37-53.5a5.416,5.416,0,0,0-5.39-5.41c-7.87-.05-26.59-.08-55.65-.08Z",
    fill: "#808184"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834",
    transform: "translate(-414.89 -2408.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(566 2409)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 18.09,
    cy: 18.09,
    r: 18.09,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(580.898 2414.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9416",
    "data-name": "Group 9416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M-.969,1.025h6.03L3.592,16.1H.52Z",
    transform: "translate(0.969 -1.025)",
    fill: "#121417"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M3.015,0A3.015,3.015,0,1,1,0,3.015,3.015,3.015,0,0,1,3.015,0Z",
    transform: "translate(0 18.09)",
    fill: "#121417"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M169.2,36.83A18.415,18.415,0,0,1,169.2,0h0a18.415,18.415,0,0,1,0,36.83Zm0-36.18a17.76,17.76,0,1,0,17.73,17.76A17.765,17.765,0,0,0,169.2.65Z",
    fill: "#808184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapSwitchOverflowHotWater);
export default __webpack_public_path__ + "static/media/air_gap_switch_overflow_hot_water.a2ac5bf086015635c986c8dc68174e31.svg";
export { ForwardRef as ReactComponent };